import React, { useState } from "react";
import Select from "react-select";
import * as funct from "../../common/manipurCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    statesList: { geographyId: string; geographyName: string }[];
}

const Guardian: React.FC<Props> = ({ formData, onChange, statesList }) => {

    const [districtsList, setDistrictsList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centersList, setCentersList] = useState<any[]>([]);

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Athlete&apos;s Aadhar</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={12}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="aadharNo"
                                        placeholder="Enter Athlete's Aadhar"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.aadharNo}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianName"
                                        required
                                        value={formData.guardianName}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Name" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianAddress"
                                        required
                                        value={formData.guardianAddress}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Address" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Mobile</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={10}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianMobile"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.guardianMobile}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Mobile" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Relationship</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianRelationship"
                                        required
                                        value={formData.guardianRelationship}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Relationship" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian&apos;s Aadhar</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={12}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianAadhar"
                                        placeholder="Enter Guardian's Aadhar"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.guardianAadhar}
                                        onChange={onChange}
                                    />
                                </div>
                                {/* <div className="col-lg-4">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="state"
                                        required
                                        value={formData.state}
                                        onChange={onChange}
                                        placeholder="Enter State" />
                                </div> */}
                                <div className="col-lg-4">
                                    <label className="form-label">State</label>
                                    <Select
                                        value={statesList.find(state => state.geographyId === formData.state) ? {
                                            value: formData.state,
                                            label: statesList.find(state => state.geographyId === formData.state)?.geographyName
                                        } : null}
                                        onChange={async (e) => {
                                            handleSelectChange("state")(e);
                                            const districtResponse = await funct.listGeoDistrictByStateId(e.value);
                                            setDistrictsList(Array.isArray(districtResponse) ? districtResponse : []);
                                        }
                                        }
                                        required
                                        placeholder="Select State"
                                        options={statesList.map(state => ({
                                            value: state.geographyId,
                                            label: state.geographyName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">District</label>
                                    {/* <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="district"
                                        required
                                        value={formData.district}
                                        onChange={onChange}
                                        placeholder="Enter District" /> */}
                                        <Select
                                        value={districtsList.find(district => district.geoDistrictsId === formData.district) ? {
                                            value: formData.district,
                                            label: districtsList.find(district => district.geoDistrictsId === formData.district)?.geoDistrictsName
                                        } : null}
                                        onChange={async (e) => {
                                            handleSelectChange("district")(e);
                                            const cityResponse = await funct.listGeoCityByDistrictId(e.value);
                                            setCityList(Array.isArray(cityResponse) ? cityResponse : []);
                                        }
                                        }
                                        required
                                        placeholder="Select District"
                                        options={districtsList.map(district => ({
                                            value: district.geoDistrictsId,
                                            label: district.geoDistrictsName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">City</label>
                                    {/* <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="city"
                                        required
                                        value={formData.city}
                                        onChange={onChange}
                                        placeholder="Enter City" /> */}
                                        <Select
                                        value={cityList.find(city => city.geoCityId === formData.city) ? {
                                            value: formData.city,
                                            label: cityList.find(city => city.geoCityId === formData.city)?.geoCityName
                                        } : null}
                                        onChange={async (e) => {
                                            handleSelectChange("city")(e);
                                            const centerResponse = await funct.listGeoCentersByCityId(e.value);
                                            setCentersList(Array.isArray(centerResponse) ? centerResponse : []);
                                        }
                                        }
                                        required
                                        placeholder="Select City"
                                        options={cityList.map(city => ({
                                            value: city.geoCityId,
                                            label: city.geoCityName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Center</label>
                                    {/* <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="center"
                                        required
                                        value={formData.center}
                                        onChange={onChange}
                                        placeholder="Enter Center" /> */}
                                        <Select
                                        value={centersList.find(center => center.geoCenterId === formData.center) ? {
                                            value: formData.center,
                                            label: centersList.find(center => center.geoCenterId === formData.center)?.geoCenterName
                                        } : null}
                                        onChange={handleSelectChange("center")}
                                        required
                                        placeholder="Select Center"
                                        options={centersList.map(center => ({
                                            value: center.geoCenterId,
                                            label: center.geoCenterName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default Guardian;